module.exports = __webpack_public_path__ + "img/98.10.899472d5.png";